module.exports = __webpack_public_path__ + "img/gift.d59b31f4.png";